export function getElementSize(el) {
    const el_style  = window.getComputedStyle(el);
    const el_display = el_style.display;
    const el_position = el_style.position;
    const el_visibility = el_style.visibility;
    const el_max_height = el_style.maxHeight.replace('px', '').replace('%', '');
    let width = 0;
    let height = 0;

    /** if it's not hidden we just return normal height */
    if ( el_display !== 'none' && el_max_height !== '0' ) {
        width = el.offsetWidth + parseInt( el_style.marginLeft, 10 ) + parseInt( el_style.marginRight, 10 );
        height = el.offsetHeight + parseInt( el_style.marginTop, 10 ) + parseInt( el_style.marginBottom, 10 );

        return { width, height };
    }

    /** the element is hidden so we making the element block so we can measure it's height but still be hidden */
    el.style.position   = 'absolute';
    el.style.visibility = 'hidden';
    el.style.display    = 'block';

    width = el.offsetWidth + parseInt( el_style.marginLeft, 10 ) + parseInt( el_style.marginRight, 10 );
    height = el.offsetHeight + parseInt( el_style.marginTop, 10 ) + parseInt( el_style.marginBottom, 10 );

    /** reverting to the original values */
    el.style.display = el_display;
    el.style.position = el_position;
    el.style.visibility = el_visibility;

    return { width, height };
}

export function getRelativePosition(el, target_width, target_height, fixed) {
    const relative_rect = el.getBoundingClientRect();
    let offset_x = 0;
    let offset_y = 0;
    let left = 0;
    let top = 0;

    if ( fixed ) {
        offset_x = window.pageXOffset + relative_rect.left;
        offset_y = window.pageYOffset + relative_rect.top;
    }

    left = offset_x;
    top = offset_y - target_height;

    return { left, top };
}